import React from "react";
import { withShowIf } from "../../with-show-if/with-show-If.component";

import { TextField as MatTextField } from "@material-ui/core";
import { TextFieldProps } from "./text-field.props";

export const TextField = withShowIf((props: TextFieldProps) => (
  <MatTextField
    {...props}
    inputProps={{
      style: {
        fontSize: "24px",
        fontWeight: "bold",
        padding: "4px",
      },
    }}
    style={{ marginRight: "12px" }}
    variant="outlined"
  />
));
